import React, { useEffect, useState, useCallback } from 'react';
import '../css/WPP8M.css';
import Login from './Login';

const API_URL = 'https://www.darparaganarwpp.com/api';

const RegistroCard = ({ file }) => {
  const [docUrl, setDocUrl] = useState(null);

  useEffect(() => {
    if (!file.filePath) return;
    const key = file.filePath.split('.amazonaws.com/')[1];
    if (!key) return;
    fetch(`${API_URL}/presign?key=${encodeURIComponent(key)}`)
      .then(r => r.json())
      .then(data => setDocUrl(data.url))
      .catch(() => setDocUrl(file.filePath));
  }, [file.filePath]);

  const fecha = file.uploadDate
    ? new Date(file.uploadDate).toLocaleDateString('es-UY', { day: '2-digit', month: 'short', year: 'numeric' })
    : '';

  return (
    <li className="reg-card">
      <div className="reg-card-header">
        <div className="reg-avatar">
          {file.userData.firstName?.[0]}{file.userData.lastName?.[0]}
        </div>
        <div>
          <p className="reg-name">{file.userData.firstName} {file.userData.lastName}</p>
          <p className="reg-date">{fecha}</p>
        </div>
      </div>
      <div className="reg-body">
        <p><strong>Correo:</strong> {file.userData.email}</p>
        <p><strong>Universidad:</strong> {file.userData.university}</p>
        <p><strong>Carrera:</strong> {file.userData.major}</p>
        <p><strong>Motivación:</strong> {file.userData.motivation}</p>
      </div>
      {docUrl && (
        <a className="reg-doc-link" href={docUrl} target="_blank" rel="noopener noreferrer">
          📎 Ver documento
        </a>
      )}
    </li>
  );
};

const UsersList = () => {
  const [files, setFiles] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const fetchRegistros = useCallback(() => {
    setLoading(true);
    fetch(`${API_URL}/registros`)
      .then(r => { if (!r.ok) throw new Error('Error en la respuesta'); return r.json(); })
      .then(data => setFiles(data))
      .catch(err => console.error('Error al recuperar archivos:', err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (isAuthenticated) fetchRegistros();
  }, [isAuthenticated, fetchRegistros]);

  const filtered = files.filter(f =>
    `${f.userData.firstName} ${f.userData.lastName} ${f.userData.email}`.toLowerCase().includes(search.toLowerCase())
  );

  if (!isAuthenticated) return <Login onLogin={() => setIsAuthenticated(true)} />;

  return (
    <div className='registrados'>
      <div className="reg-top-bar">
        <h1>Registros <span className="reg-count">{files.length}</span></h1>
        <input
          className="reg-search"
          type="text"
          placeholder="Buscar por nombre o correo..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      {loading && <p className="reg-loading">Cargando...</p>}
      {!loading && filtered.length === 0 && <p className="reg-empty">No se encontraron registros.</p>}
      <ul>
        {filtered.map(file => <RegistroCard key={file._id} file={file} />)}
      </ul>
    </div>
  );
};

export default UsersList;
